import { getAuthToken } from './auth';

export type DistributableElement = {
  elementID?: string | null;
  elementType?: string;
  QRCodeType?: string;
  active?: boolean;
  formID?: string;
  formIDs?: string[];
  eventIDs?: string[];
};

export function linkedFormIDs(element: DistributableElement): string[] {
  return [...new Set([element.formID, ...(element.formIDs || []), ...(element.eventIDs || [])]
    .filter((id): id is string => typeof id === 'string' && !!id && id !== '-'))];
}

/** Recheck primary form records: standalone elements can stay active after their parent is unpublished. */
export async function verifyElementDistribution(element: DistributableElement, paymentsReady: boolean): Promise<boolean> {
  if (!element.elementID || element.active !== true) return false;
  const ids = linkedFormIDs(element);
  if (ids.length === 0 && ['CONTACT_PORTAL', 'USER_LOGIN'].includes(element.elementType || '')) return true;
  if (!paymentsReady) return false;
  if (ids.length === 0) return element.elementType === 'QR_CODE' && element.QRCodeType === 'CUSTOM_PAGE';
  try {
    const token = await getAuthToken();
    const results = await Promise.all(ids.map(async (formID) => {
      const url = new URL(import.meta.env.VITE_APP_FORMS_URL);
      url.searchParams.set('formID', formID);
      const response = await fetch(url.toString(), { headers: { Authorization: token }, cache: 'no-store' });
      if (!response.ok) return false;
      const form = await response.json();
      return form.formID === formID && form.active === true;
    }));
    return results.every(Boolean);
  } catch {
    return false;
  }
}
